import React from 'react';

import { Text } from '@reckon-web/text';
interface IActivityPropertyInt {
  value?: string | null;
}

// ActivityProperty Int = 2
export const ActivityPropertyInt = ({ value }: IActivityPropertyInt) => {
  const formattedValue = () => {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const parsedVal = parseInt(value, 10);

    if (isNaN(parsedVal)) {
      // we tried, doesn't parse, just return the string
      return value;
    }

    // give it a splash of nice with some commas
    return parsedVal.toLocaleString();
  };
  return (
    <Text size="small" weight="semibold">
      {formattedValue()}
    </Text>
  );
};
